import React from 'react';
import ExampleVows from './ExampleVows';

const Landing = ({ onGetStarted }) => {
  const features = [
    {
      icon: 'bi-heart-fill',
      title: 'Beautifully Written',
      description: 'Eloquent, heartfelt wedding vows that capture your unique love story and commitment to each other.'
    },
    {
      icon: 'bi-pencil-square',
      title: 'Easy to Customize',
      description: 'Simple form-based interface that guides you through creating personalized vows in minutes.'
    },
    {
      icon: 'bi-file-earmark-pdf',
      title: 'Print-Ready PDFs',
      description: 'Elegant, professionally formatted vows perfect for your ceremony or keepsake book.'
    },
    {
      icon: 'bi-shield-check',
      title: 'Private & Secure',
      description: 'Your intimate words stay private. Create your vows with complete peace of mind.'
    },
    {
      icon: 'bi-arrow-repeat',
      title: 'Multiple Versions',
      description: 'Generate up to 5 different versions until you find the perfect words. No expiration.'
    },
    {
      icon: 'bi-gem',
      title: 'Capture Your Love',
      description: 'Create meaningful vows that perfectly express your feelings and promises.'
    }
  ];

  return (
    <div className="landing-section" id="features">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">Write Perfect Wedding Vows</h1>
          
          <p className="hero-subtitle">
            Express your love with beautifully crafted vows.<br />
            Personal, heartfelt, and ready for your special day.
          </p>

          <div className="d-flex flex-column flex-md-row gap-3 justify-content-center align-items-center">
            <button 
              className="btn btn-outline-primary btn-lg"
              onClick={() => {
                const examplesSection = document.getElementById('examples');
                if (examplesSection) {
                  examplesSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
              style={{ 
                color: '#5d3a3b', 
                borderColor: '#1e3a5f',
                backgroundColor: 'transparent',
                minWidth: '180px'
              }}
              onMouseEnter={(e) => {
                e.target.style.color = '#5d3a3b';
                e.target.style.backgroundColor = 'rgba(30, 58, 95, 0.1)';
                const icon = e.target.querySelector('i');
                if (icon) icon.style.color = '#5d3a3b';
              }}
              onMouseLeave={(e) => {
                e.target.style.color = '#5d3a3b';
                e.target.style.backgroundColor = 'transparent';
                const icon = e.target.querySelector('i');
                if (icon) icon.style.color = '#5d3a3b';
              }}
            >
              <i className="bi bi-eye me-2" style={{ color: '#5d3a3b' }}></i>
              <span style={{ color: '#5d3a3b' }}>View Examples</span>
            </button>
            <button 
              className="btn btn-primary btn-lg btn-with-arrow"
              onClick={onGetStarted}
            >
              Write My Vows
              <i className="bi bi-heart-fill chevron-animate ms-2"></i>
            </button>
          </div>
        </div>

        <div className="row g-4 mt-5">
          {features.map((feature, index) => (
            <div key={index} className="col-lg-4 col-md-6">
              <div className="glass-card feature-card">
                <div className="feature-icon">
                  <i className={`bi ${feature.icon}`}></i>
                </div>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Example Vows Section */}
        <ExampleVows />

        <div className="cta-section mt-5">
          <div className="glass-card cta-card text-center">
            <h2 className="cta-title mb-3">Ready to Write Your Vows?</h2>
            <p className="cta-description mb-4">
              Create beautiful, personalized wedding vows in just minutes.
            </p>
            <button 
              className="btn btn-primary btn-lg pulsate-btn btn-with-arrow"
              onClick={onGetStarted}
            >
              Write My Vows
              <i className="bi bi-heart-fill chevron-animate ms-2"></i>
            </button>
          </div>
        </div>

        {/* Free Resource Banner */}
        <div className="free-resource-section mt-4">
          <div className="glass-card text-center" style={{ 
            background: 'rgba(30, 58, 95, 0.05)',
            border: '2px dashed rgba(30, 58, 95, 0.2)'
          }}>
            <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-3">
              <div style={{ fontSize: '2.5rem' }}>📝</div>
              <div className="text-md-start text-center">
                <h3 style={{ 
                  color: '#1e3a5f', 
                  fontSize: '1.3rem', 
                  marginBottom: '0.25rem',
                  fontFamily: 'Playfair Display, Georgia, serif'
                }}>
                  Not ready yet? Get our free guide!
                </h3>
                <p style={{ color: '#5d3a3b', marginBottom: 0, fontSize: '0.95rem' }}>
                  10 Wedding Vow Prompts to help you find the perfect words.
                </p>
              </div>
              <a 
                href="/free-vow-prompts" 
                className="btn btn-secondary btn-lg"
                style={{ 
                  background: 'white',
                  color: '#1e3a5f',
                  border: '2px solid #1e3a5f',
                  whiteSpace: 'nowrap'
                }}
              >
                <i className="bi bi-download me-2"></i>
                Free Download
              </a>
            </div>
          </div>
        </div>

        {/* Poetry Quote Section */}
        <div className="poetry-section">
          <div className="row">
            <div className="col-12">
              <div className="poetry-quote">
                <p className="poetry-text">
                  I love you without knowing how, or when, or from where.<br />
                  I love you simply, without problems or pride.
                </p>
                <p className="poetry-author">~ Pablo Neruda</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
